// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiper-wrapper {
  padding: 44px 0px;
}

.policy-slide {
  width: 266px;
  transition: 0.2s all;
}

.limit-policy-details {
  display: none;
}

.swiper-slide-active .policy-slide {
  position: absolute;
  left: -40px;
  right: -40px;
  width: auto;
  scale: 1.15;
  box-shadow: 0px 0px 32px 0px #25284636;
}

.swiper-slide-active .policy-slide .limit-policy-details {
  display: block;
}

.swiper-slide-active .policy-slide .limit-purchase-button {
  color: #fff !important;
  border: none;
  background-color: var(--theme-primary);
}

.swiper-button-prev,
.swiper-button-next {
  height: 44px;
  width: 44px;
  border-radius: 50%;
  box-shadow: 0px 0px 10px 3px rgba(0, 0, 0, 0.15);
  background-color: #fff;
}

.swiper-button-prev::after,
.swiper-button-next::after {
  scale: 0.6;
  color: var(--theme-primary);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/carousel.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;;EAEE,UAAU;EACV,2BAA2B;AAC7B","sourcesContent":[".swiper-wrapper {\n  padding: 44px 0px;\n}\n\n.policy-slide {\n  width: 266px;\n  transition: 0.2s all;\n}\n\n.limit-policy-details {\n  display: none;\n}\n\n.swiper-slide-active .policy-slide {\n  position: absolute;\n  left: -40px;\n  right: -40px;\n  width: auto;\n  scale: 1.15;\n  box-shadow: 0px 0px 32px 0px #25284636;\n}\n\n.swiper-slide-active .policy-slide .limit-policy-details {\n  display: block;\n}\n\n.swiper-slide-active .policy-slide .limit-purchase-button {\n  color: #fff !important;\n  border: none;\n  background-color: var(--theme-primary);\n}\n\n.swiper-button-prev,\n.swiper-button-next {\n  height: 44px;\n  width: 44px;\n  border-radius: 50%;\n  box-shadow: 0px 0px 10px 3px rgba(0, 0, 0, 0.15);\n  background-color: #fff;\n}\n\n.swiper-button-prev::after,\n.swiper-button-next::after {\n  scale: 0.6;\n  color: var(--theme-primary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
